// @docs https://[domain]/api/v1/docs
export default {
  List: "/features",
  Detail: "/features",
  Update: "/features",
  Create: "/features",
  ListShort: "/features/short",
};
